module.exports = require('./helpers/bundle-url').getBundleURL('9zxOH') + "logo.c51670a8.svg";